
var vskoNav = angular.module('vskoNav', []);

vskoNav.controller('vskoNavController',  ['$scope', function ($scope) {
  var ctrl = this;
  var navItems = this.navItems = [];
  

  // Add
  ctrl.addNavItem = function (navItem) {
    navItems.push(navItem);
    if(navItem.index === $scope.active || (!angular.isDefined($scope.active) && navItems.length === 1)) {
      ctrl.select(navItem.index);
    }
  };

  // Select
  ctrl.select = function(index) {
    angular.forEach(navItems, function(navItem) {
        navItem.active = (navItem.index === index);
    });    
    ctrl.currentIndex = index;
    if($scope.active !== index) {
      $scope.active = index;
    }
      
  };

  $scope.$watch('active', function(val) {
    
    if (angular.isDefined(val) && val !== ctrl.currentIndex) {
      ctrl.select(val);
    }
  });
}])

.directive('vskoNav', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-nav.html'),
    transclude: true,
    replace: true,
    scope: {
      active: '=?',
      type: '@'
    },
    controller:  'vskoNavController',
    controllerAs: 'nav',
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
    }
  }
}])

.directive('vskoNavItem', ['$location', function($location) {
  return {
    restrict: 'E',
    require: '^vskoNav',
    template: require('./vsko-nav-item.html'),
    replace: true,
    transclude: true,
    scope: {
      heading: "@",
      href: '@?',
      index: '=?'
    },
    link: function(scope, element, attrs, navCtrl) {
      'use strict';
      if (angular.isDefined(attrs.disable)) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (navCtrl.navItems && navCtrl.navItems.length) {
          scope.index = Math.max.apply(null, navCtrl.navItems.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }
      navCtrl.addNavItem(scope);

      scope.select = function() {
        navCtrl.select(scope.index);
        if (angular.isDefined(scope.href)) {
          $location.path(scope.href);
        }
      }
    }
  }
}])
